module.exports = __webpack_public_path__ + "img/blood_pressure_grey.a38d6689.svg";